export const ROUTE_PATHS = {
	HOME: {
		name: "Home",
		path: "/",
	},
	LABEL_GENERATOR: {
		name: "ID Generator",
		path: "/label-generator",
	},
	LAST_CREATED: {
		name: "Last Created",
		path: "/last-created",
	},
} as const
